import { QIcon_search_default } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import { useState } from 'react'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_material_list } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import CategoryListSection from '../../new-portal/lessons/materials/CategoryListSection'
import WebviewStackContainer from '../common/WebviewStackContainer'

const SearchIcon = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const getFullUrl = useReturnFullUrl()

  const handleClickSearch = () => {
    router.push(urls.webview.aiTutor.discussion.materialSearch(), {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.aiTutor.discussion.materialSearch()),
      },
    })
  }
  return (
    <>
      <div
        className="absolute top-[0px] right-[0px] z-[10] flex cursor-pointer items-end pt-[13px] pr-[20px]"
        onClick={handleClickSearch}
      >
        <QIcon_search_default width={24} height={24} />
      </div>
    </>
  )
}

interface IMaterialCategory {
  params: {
    categoryId: string
  }
}

const AITutorDiscussionMaterialsCategoryActivity: ActivityComponentType = ({ params }: IMaterialCategory) => {
  const { t } = useTranslation()
  const { useAITutorFlow } = useAITutorStack()
  const { pop } = useAITutorFlow()
  const [selectedHashId, setSelectedHashId] = useState('All')
  const router = useAppRouter()

  const categoryId = router.query.categoryId || params.categoryId

  return (
    <WebviewStackContainer
      height="52px"
      title={t(n_material_list.all.title)}
      onBack={() => router.back()}
      appendRight={() => <SearchIcon />}
    >
      <div className="mx-[16px]">
        <CategoryListSection
          categoryId={Number(categoryId)}
          setCategoryId={null}
          selectedHashId={selectedHashId}
          setSelectedHashId={setSelectedHashId}
          isList={true}
          isAITutor={true}
        />
      </div>
    </WebviewStackContainer>
  )
}

export default AITutorDiscussionMaterialsCategoryActivity
